<script>
  import { createEventDispatcher,onMount } from "svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  import ModalConfirm from "../HTMLElements/ModalConfirm.svelte";
  import Notification from "../HTMLElements/Notification.svelte";
  export let childId;

  export let applicationId;
  let updatingApplication = false;
  let deletingApplication = false;
  let applicationToDelete = false;
  let showMessage = false;
  let modalMessage;
  let details;
  
  const dispatch = new createEventDispatcher();
  
  const getChild = async() => {
    let response =  await wrappedFetch(
      `/child/getchildren?childId=${childId}&x=${new Date().getTime()}`
    ).then(response => response.json());
    return response.children;
  };

  onMount(async()=>{
    getApplicationSummary();
    await getChild().then(result => {
    let application = result[0].applications.filter(
      a => a.applicationId == applicationId
    );
    if(application.length == 0 || !application[0].isApplicationDeleteable)
    {
      dispatch('pageRedirect',{url:'/user/home/'});
    }
  });
  
  })

  const getApplicationSummary = () => {
    return wrappedFetch(
      "child/getapplicationsummary?applicationId=" +
        applicationId +
        "&x=" +
        new Date().getTime()
    )
      .then(response => response.json())
      .then(result => {
        details=result;
        return result;
      });
  };

  const deleteApplication = () => {
    let form = new FormData();
    form.append("id", applicationId);
     form.append("childId", childId);
    deletingApplication = true;
    wrappedFetch(`/child/DeleteApplication`, {
      method: "post",
      body: form
    })
      .then(response => response.json())
      .then(async response => {
        if (response.success) {
          applicationToDelete = null;
          // Children.set(await getChildren());
          modalMessage = "Application deleted successfully.";
          showMessage = true;
          dispatch("notification", "Application deleted successfully.");
          dispatch("pageChange", "/user/home/");
        }
        deletingApplication = false;
      });
  };
</script>
<svelte:head>
  <title>Application Delete</title>
</svelte:head>
{#if details}
  <section class="section">
    <div class="container">
      <div class="columns is-centered is-desktop">
        <div class="column is-10-desktop">
          <div
            class="step-14-shows"
            style="word-break: break-word;overflow-wrap: break-word;">
            <div class="field">
              <a href="/user/home">
                <span class="fas fa-arrow-left" />
                Back
              </a>
            </div>
            <h1 class="title is-3">Delete application</h1>
            <nav class="panel" tabindex="0" style="margin-top: 15px;">
              <div
                class="panel-heading"
                style="display: flex;align-items: stretch;font-size: inherit;">
                
                  <strong>Child details</strong>
              
                <!-- <a href="application-step1.html?1" class="" aria-label="more options">
          Change
        </a>
        <a href="#" class="" aria-label="more options">
          <span class="icon">
            <span class="fas fa-angle-down" aria-hidden="true" />
          </span>
        </a> -->
              </div>
              <div class="panel-block">
                <div class="column">Child name</div>
                <div class="column">
                  <strong>
                    {details.child.forename}
                    {details.child.middleName ? details.child.middleName : ''}
                    {details.child.surname}
                  </strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Address</div>
                <div class="column">
                  <strong>
                    {#each details.childAddress.split(',') as addr}
                    {addr}<br/>
                    {/each}
                  </strong>
                </div>
              </div>
              {#if details.child.councilTaxRef && details.child.councilTaxRef != ''}
                <div class="panel-block">
                  <div class="column">Council tax account number</div>
                  <div class="column">
                    <strong>{details.child.councilTaxRef}</strong>
                  </div>
                </div>
              {/if}
              <div class="panel-block">
                <div class="column">Date of birth</div>
                <div class="column">
                  <strong>{details.child.dobStr}</strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Sex</div>
                <div class="column">
                  <strong>{details.child.genderDetail}</strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Multiple births</div>
                <div class="column">
                  <strong>
                    {#if details.multipleBirth == 'Y'}Yes{:else}No{/if}
                  </strong>
                </div>
              </div>
              {#if  details.child.inCareId > 0 && details.child.inCareAuthorityName != ''}
                <div class="panel-block">
                  <div class="column">
                    Child is in the care of or has previously been in the care
                    of {details.child.inCareAuthorityName}
                  </div>
                </div>
              {/if}
              {#if details.child.statement == 'Y'}
                <div class="panel-block">
                  <div class="column">Child has an EHCP</div>
                </div>
              {/if}
              {#if details.child.educationStatus == 'NOTATSCHOOL'}
                <div class="panel-block">
                  <div class="column">The child is not currently at school</div>
                </div>
              {:else if details.child.educationStatus == 'HOME'}
                <div class="panel-block">
                  <div class="column">
                    Child is currently being educated at home
                  </div>
                </div>
              {:else if details.child.educationStatus == 'ABROAD'}
                <div class="panel-block">
                  <div class="column">Child has been educated abroad</div>
                </div>
              {:else if details.child.educationStatus == 'NOTFOUND' && details.child.currentSchoolNameTyped && details.child.currentSchoolNameTyped != ''}
                <div class="panel-block">
                  <div class="column">Current school name entered</div>
                  <div class="column">
                    <strong>{details.child.currentSchoolNameTyped}</strong>
                  </div>
                </div>
              {:else if details.child.currentSchoolId > 0 && details.child.currentSchoolName != ''}
                <div class="panel-block">
                  <div class="column">Child's current school</div>
                  <div class="column">
                    <strong>{details.child.currentSchoolName}</strong>
                    {#if details.child.school.address}
                      {#each details.child.school.address.split(',') as addr}
                      {addr}<br/>
                      {/each}
                    {/if}
                  </div>
                </div>
              {/if}
              {#if details.laAnswers && details.laAnswers != null}
                {#each details.laAnswers.split(';') as list}
                  <div class="panel-block">
                    <div class="column">{list.split('=')[0]}</div>
                    <div class="column">
                      <strong>{list.split('=')[1]}</strong>
                    </div>
                  </div>
                {/each}
              {/if}
              <div class="panel-block">
                <div class="column">Number of schools applied</div>
                <div class="column">
                  <strong>
                    {details.preferences.length} out of {details.borough.maxPref}
                  </strong>
                </div>
              </div>
            </nav>

            <nav class="panel" tabindex="0" style="margin-top: 15px;">
              <div
                class="panel-heading"
                style="display: flex;align-items: stretch;font-size: inherit;">
              <strong>
                  Your details
                </strong>
                <!-- <a href="application-step1.html?1" class="" aria-label="more options">
          Change
        </a>
        <a href="#" class="" aria-label="more options">
          <span class="icon">
            <span class="fas fa-angle-down" aria-hidden="true" />
          </span>
        </a> -->
              </div>
              <div class="panel-block">
                <div class="column">Name</div>
                <div class="column">
                  <strong>
                    {#if details.parentTitle} {details.parentTitle} {/if} {details.parentForename}
                    {details.parentSurname}
                  </strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Relationship</div>
                <div class="column">
                  <strong>{details.relationshipDetail}</strong>
                </div>
              </div>
              <div class="panel-block">
                <div class="column">Parental Responsibility</div>
                <div class="column">
                  <strong>
                    {#if details.child.responsibility == 'Y'}Yes{:else}No{/if}
                  </strong>
                </div>
              </div>

              <div class="panel-block">
                <div class="column">Address</div>
                <div class="column">
                  <strong>
                    {#each details.parentAddress.split(',') as addr}
                     {addr}<br/>
                    {/each}
                  </strong>
                </div>
              </div>

              {#if details.parentWorkPhone && details.parentWorkPhone != ''}
                <div class="panel-block">
                  <div class="column">Work number</div>
                  <div class="column">
                    <strong>{details.parentWorkPhone}</strong>
                  </div>
                </div>
              {/if}
              {#if details.parentHomePhone && details.parentHomePhone != ''}
                <div class="panel-block">
                  <div class="column">Home number</div>
                  <div class="column">
                    <strong>{details.parentHomePhone}</strong>
                  </div>
                </div>
              {/if}
              {#if details.parentMobile && details.parentMobile != ''}
                <div class="panel-block">
                  <div class="column">Mobile number</div>
                  <div class="column">
                    <strong>{details.parentMobile}</strong>
                  </div>
                </div>
              {/if}
              {#if details.parentEmail && details.parentEmail != ''}
                <div class="panel-block">
                  <div class="column">Email</div>
                  <div class="column">
                    <strong>{details.parentEmail}</strong>
                  </div>
                </div>
              {/if}
              {#if details.isCrownService == 'Y'}
                <div class="panel-block">
                  <div class="column">In Crown Service</div>
                  <div class="column">
                    <strong>Priority Requested</strong>
                  </div>
                </div>
              {/if}
              {#if details.personalDetailAccepted == 'Y'}
                <div class="panel-block">
                  <div class="column">Personal details</div>
                  <div class="column">
                    <strong>Confirmed</strong>
                  </div>
                </div>
              {/if}
              {#if details.privacyPolicyAccepted == 'Y'}
                <div class="panel-block">
                  <div class="column">Privacy policy</div>
                  <div class="column">
                    <strong>Accepted</strong>
                  </div>
                </div>
              {/if}
              {#if details.child.scSkip && details.child.scSkip != 'Y'}
                {#if details.child.scSurname && details.child.scSurname != null}
                  <div class="panel-block">
                    <div class="column">Second contact name</div>
                    <div class="column">
                      <strong>
                        {details.child.scForename ? details.child.scForename : ''}
                        {details.child.scSurname ? details.child.scSurname : ''}
                      </strong>
                    </div>
                  </div>
                {/if}
                {#if details.child.scSscRelationshipurname && details.child.scRelationship != null}
                  <div class="panel-block">
                    <div class="column">Second contact relationship</div>
                    <div class="column">
                      <strong>{details.child.scRelationship}</strong>
                    </div>
                  </div>
                {/if}
              {/if}
            </nav>

            <!-- school preferences block -->
            <nav class="panel" tabindex="0" style="margin-top: 15px;">
              {#each details.preferences as preference}
                <div
                  class="panel-heading"
                  style="display: flex;align-items: stretch;font-size: inherit;">
                  <p style="display: flex;flex-grow: 1;align-items: center;">
                    {preference.preferenceSummary.ordinalSequence} Preference
                    School
                  </p>
                  <!-- <a href="application-step1.html?6" class="" aria-label="more options">
            Change
          </a>
          <a href="#" class="" aria-label="more options">
            <span class="icon">
              <span class="fas fa-angle-down" aria-hidden="true" />
            </span>
          </a> -->
                </div>
                <div class="panel-block">
                  <div class="column">Address</div>
                  <div class="column">
                    <strong>
                      {preference.preferenceSummary.schoolName}
                      <br />
                      {#each preference.preferenceSummary.address.split(',') as addr}
                      {addr}<br/>
                      {/each}
                    </strong>
                  </div>
                </div>
                {#if preference.sibling}
                  <div class="panel-block">
                    <div class="column">Sibling name</div>
                    <div class="column">
                      <strong>
                        {preference.sibling.forename}
                        {preference.sibling.middleName ? preference.sibling.middleName : ''}
                        {preference.sibling.surname}
                      </strong>
                    </div>
                  </div>
                  <div class="panel-block">
                    <div class="column">Sibling address</div>
                    <div class="column">
                      <strong>
                        {#each preference.sibling.address.split(',') as addr}
                        {addr}<br/>
                        {/each}
                      </strong>
                    </div>
                  </div>
                  <div class="panel-block">
                    <div class="column">Sibling date of birth</div>
                    <div class="column">
                      <strong>{preference.sibling.dobStr}</strong>
                    </div>
                  </div>

                  <div class="panel-block">
                    <div class="column">Sex of sibling</div>
                    <div class="column">
                      <strong>{preference.sibling.genderDetail}</strong>
                    </div>
                  </div>
                  <div class="panel-block">
                    <div class="column">Sibling school</div>
                    <div class="column">
                      <strong>{preference.sibling.currentSchoolName}</strong>
                    </div>
                  </div>
                {/if}
                {#if preference.preferenceSummary.staffChild == 'Y'}
                  <div class="panel-block">
                    <div class="column">Staff Member</div>
                    <div class="column">
                      <strong>Priority Requested</strong>
                    </div>
                  </div>
                          
                  <div class="panel-block">
                    <div class="column">Staff members name</div>
                    <div class="column">
                      {preference.preferenceSummary.stafffName} {preference.preferenceSummary.stafflName}
                    </div>
                  </div>
                {/if}
                {#if preference.preferenceSummary.medical == 'Y'}
                  <div class="panel-block">
                    <div class="column">Medical reason</div>
                    <div class="column">
                      <strong>Priority Requested</strong>
                    </div>
                  </div>
                {/if}
                {#if preference.preferenceSummary.social == 'Y'}
                  <div class="panel-block">
                    <div class="column">Social reason</div>
                    <div class="column">
                      <strong>Priority Requested</strong>
                    </div>
                  </div>
                {/if}
                {#if preference.preferenceSummary.reason && preference.preferenceSummary.reason != ''}
                  <div class="panel-block">
                    <div class="column">Additional reason</div>
                    <div class="column">
                      <strong>
                        {@html preference.preferenceSummary.reason}
                      </strong>
                    </div>
                  </div>
                {/if}
                {#if preference.information && preference.information != null}
                  <div class="panel-block">
                    <div class="column">Important school information</div>
                    <div class="column">
                      {@html preference.information}
                    </div>
                  </div>
                {/if}
                {#if preference.warningText && preference.warningText != null}
                  <div class="panel-block">
                    <div class="column">Supplementary information form</div>
                    <div class="column">
                      {@html preference.warningText}
                    </div>
                  </div>
                {/if}
                <br />
              {/each}
            </nav>
            <hr />
            <div>

              <div class="buttons is-right" style="margin-top: 15px;">
                <a href="/user/home/" class="button">Cancel</a>
                <button
                  on:click={(e) => {
                    e.preventDefault();                   
                    applicationToDelete = true;
                  }}
                  class="button is-primary">
                  Delete application
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
  </section>
{/if}

<ModalConfirm showModal={applicationToDelete} on:ok={deleteApplication} bind:isUpdating={deletingApplication}>
  Are you sure you want to delete this application?
</ModalConfirm>
